var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_3535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.319 31.855C35.7141 33.2524 34.9981 34.5388 34.1684 35.7215C33.0376 37.3338 32.1117 38.4498 31.3982 39.0696C30.292 40.0868 29.1069 40.6078 27.8378 40.6374C26.9267 40.6374 25.828 40.3782 24.549 39.8522C23.2658 39.3288 22.0866 39.0696 21.0084 39.0696C19.8775 39.0696 18.6647 39.3288 17.3675 39.8522C16.0683 40.3782 15.0217 40.6522 14.2214 40.6794C13.0044 40.7312 11.7914 40.1954 10.5806 39.0696C9.80775 38.3955 8.84111 37.24 7.68312 35.603C6.44069 33.8549 5.41924 31.8278 4.61902 29.5168C3.76201 27.0205 3.3324 24.6033 3.3324 22.2631C3.3324 19.5825 3.91164 17.2705 5.07185 15.333C5.98367 13.7767 7.19672 12.5491 8.71494 11.6479C10.2332 10.7467 11.8736 10.2875 13.6402 10.2581C14.6069 10.2581 15.8745 10.5571 17.4497 11.1447C19.0205 11.7343 20.0291 12.0333 20.4714 12.0333C20.802 12.0333 21.9224 11.6837 23.8219 10.9867C25.6181 10.3403 27.1341 10.0726 28.376 10.1781C31.7414 10.4497 34.2697 11.7763 35.9511 14.1664C32.9413 15.99 31.4525 18.5442 31.4821 21.8209C31.5093 24.3732 32.4352 26.4971 34.2549 28.1835C35.0795 28.9662 36.0005 29.5711 37.0251 30.0007C36.8029 30.6451 36.5684 31.2624 36.319 31.855ZM28.6007 1.48303C28.6007 3.48349 27.8699 5.35131 26.4131 7.08014C24.6552 9.13539 22.5288 10.323 20.223 10.1356C20.1936 9.89561 20.1765 9.64303 20.1765 9.37761C20.1765 7.45717 21.0126 5.40192 22.4972 3.72148C23.2384 2.87064 24.1811 2.16318 25.3243 1.59883C26.465 1.04289 27.544 0.735449 28.5588 0.6828C28.5884 0.95023 28.6007 1.21768 28.6007 1.483V1.48303Z",
    fill: "url(#paint0_linear_1959_3535)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1959_3535",
    x1: 3.3324,
    y1: 20.6828,
    x2: 37.0251,
    y2: 20.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_3535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.681885)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.b06fee7c30346d61d2c1880697ef2791.svg";
export { ForwardRef as ReactComponent };